import { useState, useRef, useEffect } from "react";
import { Tooltip } from "@mui/material";
import styles from "./styles.module.css";

type Props = {
  text: string;
};

export function TextOverflow(props: Props) {
  const { text } = props;
  const [isOverflowed, setIsOverflow] = useState(false);
  const textElementRef = useRef<HTMLSpanElement>(null);

  const resizeHandler = () => {
    if (textElementRef.current) {
      const isLonger =
        textElementRef.current.scrollWidth > textElementRef.current.offsetWidth;
      if (isLonger) setIsOverflow(true);
    }
  };

  useEffect(() => {
    resizeHandler();
  }, []);

  return (
    <span className={styles.textEllipsis}>
      <Tooltip
        arrow
        placement="top"
        disableHoverListener={!isOverflowed}
        title={text}
      >
        <span ref={textElementRef}>{text}</span>
      </Tooltip>
    </span>
  );
}
